import React  from "react";
import {Card} from "antd";

import {BookingEligibleDriversParams} from "../../types/bookingTypes";

const BookingEligibleDrivers = ({eligibleDrivers}: BookingEligibleDriversParams) => {

    return (
        <Card title="Eligible Drivers" className="booking-manage-details-card">
            {
                eligibleDrivers && eligibleDrivers.length > 0 ?
                eligibleDrivers.map((driver) => {
                    return (
                        <p key={driver.id}>
                           {driver.account_number}-{driver.membership_number} {driver.full_name}
                        </p>
                    )
                }) : 'N/A'
            }
        </Card>
    )
}

export default BookingEligibleDrivers;
